import React from 'react'
import SupplierShape from './prop_shapes/supplier'
import SupplierDesignations from '../supplier_shared/SupplierDesignations'
import { isEmpty } from 'lodash-es'

const OverviewAbout = ({ supplier: { description, pro, designations, claimed } }) => {
  const renderTags = () => {
    const designationTitles = designations.map(designation => designation.name)

    const fullDesignations = () => {
      if (pro) {
        return ['Pro'].concat(designationTitles)
      } else if (claimed) {
        return ['Claimed'].concat(designationTitles)
      } else {
        return designationTitles
      }
    }

    return <SupplierDesignations designations={fullDesignations()} includeTooltips />
  }

  const renderAboutContent = () => (
    <div className='about-us'>
      <h3 className='pro-head-6'>About Us</h3>
      <p className='pro-text-l word-wrap'>{description}</p>
    </div>
  )

  if (description || pro || claimed || !isEmpty(designations)) {
    return (
      <div className='pro-padded pro-bordered padding-3 color-pro-steel-grey-600'>
        {description ? renderAboutContent() : null}
        {(pro || claimed || designations.length > 0) ? renderTags() : null}
      </div>
    )
  } else {
    return (
      <></>
    )
  }
}

OverviewAbout.propTypes = {
  supplier: SupplierShape
}

OverviewAbout.defaultProps = {
  supplier: { description: null, pro: false, designations: [], claimed: false }
}

export default OverviewAbout
